import React, { useRef, useEffect, createContext } from 'react'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN';
import s from './index.module.scss'

interface Iprops {
  children: React.FC | React.ReactElement
}

export const DefaultContext = createContext({})

function BasicLayout(props: Iprops) {
  const { children, ...otherProps } = props

  return (
    <DefaultContext.Provider value={{}}
    >
      <ConfigProvider locale={zhCN}>
        <div className={`${s.layout} main-layout`}>
          {props.children}
        </div>
      </ConfigProvider>
    </DefaultContext.Provider>
  )
}

export default BasicLayout
